/* eslint-disable */
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IInvoiceModel, Sorting } from '../../models/invoices/invoices.model';
import { compareByPropertyAsc } from '../utils/compare.utils';
import { ConfigService } from '@uxdf/direct-shared-lib';
import { InvoiceDownloadAPI } from '../../models/invoices/invoice-download-api';

@Injectable({
  providedIn: 'root'
})
export class InvoicesService {
  component_url = {
    invoices: () => 'api/amadeus/invoices',
    avcInvoices: () => 'api/amadeus/avc-invoices',
    invoicesConfig: store => 'rest/' + store + '/V1/amadeus/public/invoice/config'
  };

  constructor(
    private readonly httpClient: HttpClient,
    private readonly initService: ConfigService
  ) {}

  getInvoices(): Observable<IInvoiceModel[]> {
    return this.httpClient.get<IInvoiceModel[]>(this.initService.getEnvConfig().AD_JAVA_API_URL + this.component_url.invoices(), {
      responseType: 'json'
    });
  }
  getInvoicesWithStatus(agencyCustomerNumber?:string): Observable<InvoiceDownloadAPI.IInvoicesResponsesWithStatus> {    
      return this.httpClient.get<InvoiceDownloadAPI.IInvoicesResponsesWithStatus>(      
      `${this.initService.getEnvConfig().AD_JAVA_API_URL}${this.component_url.invoices()}${agencyCustomerNumber ? `?agencyCustomerNumber=${agencyCustomerNumber}`:''}`,
      {
        responseType: 'json'
      }
    );
  }
  getAvcInvoicesWithStatus(): Observable<InvoiceDownloadAPI.IInvoicesResponsesWithStatus> {   
    return this.httpClient.get<InvoiceDownloadAPI.IInvoicesResponsesWithStatus>(      
    `${this.initService.getEnvConfig().AD_JAVA_API_URL}${this.component_url.avcInvoices()}`,
    {
      responseType: 'json'
    }
  );
}
}

export function sortInovoices(direction: Sorting, allInvoices: IInvoiceModel[]): Observable<any[]> {
  if (direction === Sorting.asc || direction === Sorting.def) {
    allInvoices.sort((a, b) => compareByPropertyAsc(a, b, 'fileDate'));
  } else {
    allInvoices.sort((a, b) => compareByPropertyAsc(b, a, 'fileDate'));
  }
  return of(allInvoices);
}
